import get from 'lodash/get';
import find from 'lodash/find';
import * as actions from 'actions/personApiKey';
import { upsertById } from '../utils';

export const defaultState = {
  persons: {},
};

export function changePersonState(state, personId, props) {
  return {
    ...state,
    persons: {
      ...state.persons,
      [personId]: {
        ...get(state, ['persons', personId], {}),
        ...props,
      },
    },
  };
}

export default function personApiKeys(state = defaultState, action) {
  const { type, payload } = action;
  const { personId, apiKey } = action.initialPayload || payload || {};

  switch (type) {
    case actions.PAK_SET_API_KEY_TO_EDIT:
      return changePersonState(state, personId, {
        editApiKey: find(state.persons[personId].apiKeys, { apiKey }),
      });
    case actions.PAK_FETCH_PERSON_API_KEYS_START:
      return changePersonState(state, personId, {
        loading: true,
      });
    case actions.PAK_FETCH_PERSON_API_KEYS_FAIL:
      return changePersonState(state, personId, {
        loading: false,
        error: payload,
      });
    case actions.PAK_FETCH_PERSON_API_KEYS_SUCCESS:
      return changePersonState(state, personId, {
        loading: false,
        error: undefined,
        apiKeys: payload.data.map(item => ({
          ...item,
          id: item.apiKey,
          secret: undefined,
        })),
      });
    case actions.PAK_DELETE_PERSON_API_KEY_SUCCESS:
      return changePersonState(state, personId, {
        apiKeys: get(state, ['persons', personId, 'apiKeys'], []).filter(
          item => item.apiKey !== payload.apiKey,
        ),
      });
    case actions.PAK_SAVE_PERSON_API_KEY_START:
      return changePersonState(state, personId, {
        saveLoading: true,
        saveError: undefined,
      });
    case actions.PAK_SAVE_PERSON_API_KEY_FAIL:
      return changePersonState(state, personId, {
        saveLoading: false,
        saveError: payload,
      });
    case actions.PAK_SAVE_PERSON_API_KEY_SUCCESS:
      return changePersonState(state, personId, {
        saveLoading: false,
        apiKeys: upsertById(
          get(state, ['persons', personId, 'apiKeys'], []),
          payload.apiKey,
          {
            ...payload,
            secret: undefined,
            id: payload.apiKey,
          },
          { prepend: true },
        ),
        editApiKey: { ...payload, secret: undefined },
      });
    case actions.PAK_EDIT_PERSON_API_KEY_DONE: {
      const apiKeyToUpdate = get(state.persons[personId], 'editApiKey.apiKey');

      if (!apiKeyToUpdate) {
        return state;
      }

      return changePersonState(state, personId, {
        editApiKey: undefined,
        apiKeys: upsertById(
          get(state, ['persons', personId, 'apiKeys'], []),
          apiKeyToUpdate,
          value => ({
            ...value,
            secret: undefined,
          }),
        ),
      });
    }
    default:
      return state;
  }
}
